<template>
  <Transition
    enter-active-class="transition-transform duration-500 ease-out"
    enter-from-class="-translate-y-full"
    enter-to-class="translate-y-0"
    leave-active-class="transition-transform duration-300 ease-in"
    leave-from-class="translate-y-0"
    leave-to-class="-translate-y-full">
    <div
      v-if="showBanner"
      class="fixed top-0 right-0 left-0 z-50 bg-gradient-to-r from-blue-600 to-blue-700 shadow-lg dark:from-blue-500 dark:to-blue-600">
      <div class="px-4 py-4">
        <!-- Header with icon and close button -->
        <div class="flex justify-between items-start mb-3">
          <div class="flex gap-3 items-center">
            <div class="flex-shrink-0 p-2 rounded-full bg-white/20 dark:bg-white/30">
              <svg
                class="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
            </div>
            <div>
              <p class="text-base font-semibold text-white">
                New Update Available
              </p>
              <p class="mt-0.5 text-xs text-blue-100">
                Get the latest features
              </p>
            </div>
          </div>

          <button
            @click="handleDismiss"
            class="p-1 -mt-1 -mr-1 text-white/80 hover:text-white"
            aria-label="Dismiss">
            <svg
              class="w-5 h-5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Update button -->
        <button
          @click="handleUpdate"
          class="py-3 w-full font-semibold text-blue-600 bg-white rounded-xl shadow-lg transition-transform duration-150 active:scale-95">
          Update Now
        </button>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { clearCacheAndReload } from '@/utils';

// import { updateSW } from '@/pwa';
const showBanner = ref(false);

onMounted(() => {
  // Check if update is available
  const updateAvailable = localStorage.getItem('updateAvailable');
  if (updateAvailable === 'true') {
    // Small delay for smooth animation on page load
    setTimeout(() => {
      showBanner.value = true;
    }, 500);
  }

  // Listen for custom event if you want to trigger it from elsewhere
  window.addEventListener('show-update-banner', () => {
    showBanner.value = true;
  });
});

const handleUpdate = () => {
  try {
    // Clear the flag before reloading
    localStorage.removeItem('updateAvailable');
    clearCacheAndReload();

  }catch(e) {
    console.log(e)
  }finally {
    showBanner.value = false;
  }
};

const handleDismiss = () => {
  // Remove from localStorage
  localStorage.removeItem('updateAvailable');

  // Hide banner with animation
  showBanner.value = false;
};
</script>
